import styled from "styled-components";
import { BodyDefault } from "../../typography/styled";


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 20px 20px;
  box-sizing: border-box;
  /* width: 400px; */
  /* height: 350px; */
  left: 540px;
  top: 305px;
  background: ${({theme}) => theme.palette[10]};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`


export const HeadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 20px;
`
export const BodyModal = styled.div`
  display:flex;
  width: 310px;
  flex-direction: column;
  align-items: center;
  gap:8px;
  /* padding:0px 10px; */
  text-align: center;
`

export const Icon = styled.img`
  &:hover{
    cursor: pointer;
  }
`